import { Plus, Trash } from "@phosphor-icons/react";
import { Section } from "./Section";

export default function CertificationsSection({ resume, setResume, open, onToggle }) {
  const add = () =>
    setResume((r) => ({
      ...r,
      certifications: [...r.certifications, { id: crypto.randomUUID(), name: "", issuer: "", date: "" }],
    }));
  const update = (i, k, v) =>
    setResume((r) => {
      const next = [...r.certifications];
      next[i] = { ...next[i], [k]: v };
      return { ...r, certifications: next };
    });
  const remove = (i) =>
    setResume((r) => ({ ...r, certifications: r.certifications.filter((_, idx) => idx !== i) }));

  return (
    <Section id="certifications" title="Certifications" open={open} onToggle={onToggle}>
      <div className="space-y-4">
        {resume.certifications.map((c, i) => (
          <div key={c.id} className="border border-black/10 p-4 space-y-3" data-testid={`cert-item-${i}`}>
            <div className="flex items-center justify-between">
              <div className="label-mono">Certificate {i + 1}</div>
              {resume.certifications.length > 1 && (
                <button onClick={() => remove(i)} className="text-neutral-400 hover:text-[#FF2A00]" data-testid={`remove-cert-${i}`}>
                  <Trash size={14} weight="bold" />
                </button>
              )}
            </div>
            <div className="grid grid-cols-3 gap-3">
              <input className="field-input col-span-2" placeholder="Name" value={c.name} onChange={(e) => update(i, "name", e.target.value)} data-testid={`cert-name-${i}`} />
              <input className="field-input" placeholder="Date" value={c.date} onChange={(e) => update(i, "date", e.target.value)} data-testid={`cert-date-${i}`} />
              <input className="field-input col-span-3" placeholder="Issuer" value={c.issuer} onChange={(e) => update(i, "issuer", e.target.value)} data-testid={`cert-issuer-${i}`} />
            </div>
          </div>
        ))}
        <button onClick={add} className="btn-secondary text-xs px-4 py-2" data-testid="add-cert-button">
          <Plus size={14} weight="bold" /> Add certification
        </button>
      </div>
    </Section>
  );
}
